import React, { useContext, useEffect, useState } from "react";
import { BsCartCheckFill, BsShop } from "react-icons/bs";
import { SlNotebook } from "react-icons/sl";
import { FaMapMarkedAlt, FaStore, FaUserFriends } from "react-icons/fa";
import { PiNotebookThin } from "react-icons/pi";
import {
  MdContentPaste,
  MdDeliveryDining,
  MdOutlineApproval,
  MdOutlineCancel,
  MdOutlineDeliveryDining,
  MdOutlineEmail,
  MdOutlineTextsms,
  MdToday,
} from "react-icons/md";
import { SlUserFollowing } from "react-icons/sl";
import { BsReceiptCutoff } from "react-icons/bs";
import { SlBasketLoaded } from "react-icons/sl";
import { SlWallet } from "react-icons/sl";
import { CiStar, CiWallet } from "react-icons/ci";
import styles from "./sideBar.module.css";
import { CiCreditCard1 } from "react-icons/ci";
import { SlUser } from "react-icons/sl";
import {
  RiAdvertisementLine,
  RiCoupon3Line,
  RiCustomerService2Line,
  RiStore2Line,
} from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { BsMenuButtonWide } from "react-icons/bs";
import { LuBadgePercent, LuBoxes } from "react-icons/lu";
import { TbBoxPadding, TbTruckReturn, TbZoomReplace } from "react-icons/tb";
import { TbTruckDelivery } from "react-icons/tb";
import { CiDeliveryTruck } from "react-icons/ci";
import { IoPrintOutline } from "react-icons/io5";
// import { SlUserFollowing } from "react-icons/sl";
import { SlDocs } from "react-icons/sl";
import { IoSettingsOutline } from "react-icons/io5";
import { TfiPrinter, TfiUser } from "react-icons/tfi";
import { GiSandsOfTime } from "react-icons/gi";
import { MdOutlineLocalOffer } from "react-icons/md";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { TbMessage2Cancel } from "react-icons/tb";
import { VscReferences } from "react-icons/vsc";
import { TiGroupOutline } from "react-icons/ti";
import { CgUiKit } from "react-icons/cg";
import { LiaBuromobelexperte } from "react-icons/lia";
import { SiHyperskill } from "react-icons/si";
import { AiOutlineTruck } from "react-icons/ai";
import { GrLocationPin, GrMapLocation } from "react-icons/gr";
import RouterContext from "../../Router/routerContext";
import { BiCategoryAlt } from "react-icons/bi";

function SideBar({ handleActiveMenu }) {
  const { fileteredRotues } = useContext(RouterContext);
  const location = useLocation();

  const [navItems, setNavItems] = useState([
    {
      id: 1,
      Icon: BsShop,
      label: "Dashboard",
      isActive: true,
      link: "dashboard",
    },
    {
      id: 2,
      Icon: SlNotebook,
      label: "Order",
      isActive: false,
      link: "order/all-orders",
      submenus: [
        {
          accordion: "Order",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "All ",
              Icon: MdContentPaste,
              isActive: false,
              link: "order/all-orders",
            },
            {
              id: 2,
              label: "Pending",
              Icon: GiSandsOfTime,
              isActive: false,
              link: "order/pending-orders",
            },
            {
              id: 3,
              label: "Accepted ",
              Icon: MdToday,
              isActive: false,
              link: "order/accepted-orders",
            },
            {
              id: 5,
              label: "Dispatch",
              Icon: BsCartCheckFill,
              isActive: false,
              link: "order/dispatch",
            },
            {
              id: 4,
              label: "Delivered",
              Icon: CiDeliveryTruck,
              isActive: false,
              link: "order/delivered-orders",
            },

            {
              id: 6,
              label: "Cancel ",
              Icon: MdOutlineCancel,
              isActive: false,
              link: "order/cancel-order",
            },

            {
              id: 7,
              label: "Replacement",
              Icon: TbZoomReplace,
              isActive: false,
              link: "order/replacement",
            },
          ],

          // menu: [
          //   {
          //     id: 1,
          //     label: "Orders",
          //     Icon: LuShoppingCart,
          //     isActive: false,
          //     link: "running-order/order",
          //   },
          //   {
          //     id: 2,
          //     label: "Table Booking",
          //     Icon: GiNotebook,
          //     isActive: false,
          //     link: "running-order/table-boking",
          //   },
          //   {
          //     id: 3,
          //     label: "Delivery",
          //     Icon: MdOutlineDeliveryDining,
          //     isActive: false,
          //     link: "running-order/delivery-order",
          //   },
          //   {
          //     id: 4,
          //     label: "Dispatch",
          //     Icon: SlUserFollowing,
          //     isActive: false,
          //     link: "running-order/dispatch",
          //   },
          // ],
        },
        {
          accordion: "Returns",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "All ",
              Icon: TbTruckReturn,
              isActive: false,
              link: "order/return-order",
            },
            {
              id: 2,
              label: "Pending",
              Icon: TbTruckReturn,
              isActive: false,
              link: "order/pending-returns",
            },
            {
              id: 3,
              label: "Accepted ",
              Icon: TbTruckReturn,
              isActive: false,
              link: "order/accepted-returns",
            },
            {
              id: 4,
              label: "Returned",
              Icon: TbTruckReturn,
              isActive: false,
              link: "order/returned-orders",
            },
          ],
        },
        {
          accordion: "Review",
          isActive: false,
          menu: [
            // {
            //   id: 1,
            //   label: "Order Review",
            //   Icon: BsReceiptCutoff,
            //   isActive: false,
            //   link: "review/order-review",
            // },
            // {
            //   id: 2,
            //   label: "Store Review",
            //   Icon: MdOutlineStarRate,
            //   isActive: false,
            //   link: "review/delivery-review",
            // },
            {
              id: 1,
              label: "Store",
              Icon: CiStar,
              isActive: false,
              link: "order/store-reviews",
            },
            {
              id: 2,
              label: "Product",
              Icon: CiStar,
              isActive: false,
              link: "order/product-reviews",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      Icon: FaMapMarkedAlt,
      label: "Map View",
      isActive: false,
      link: "map-view/store-location",
      submenus: [
        {
          accordion: "location",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Store",
              Icon: BsReceiptCutoff,
              isActive: false,
              link: "map-view/store-location",
            },
            {
              id: 2,
              label: "Delivery Man",
              Icon: MdDeliveryDining,
              isActive: false,
              link: "map-view/provider-location",
            },
            {
              id: 3,
              label: "Delivery Tracking",
              Icon: GrMapLocation,
              isActive: false,
              link: "map-view/delivery-man-tracking",
            },
          ],
        },
      ],
    },
    {
      id: 4,
      Icon: PiNotebookThin,
      label: "Earning",
      isActive: false,
      link: "earnings/order",
      submenus: [
        {
          accordion: "Earning",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Order",
              Icon: SlBasketLoaded,
              isActive: false,
              link: "earnings/order",
            },
            {
              id: 2,
              label: "Delivery Man",
              Icon: MdOutlineDeliveryDining,
              isActive: false,
              link: "earnings/deliveryman",
            },
            {
              id: 3,
              label: "Store",
              Icon: BsShop,
              isActive: false,
              link: "earnings/store",
            },
          ],
        },
        {
          accordion: "Wallet",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Wallet History",
              Icon: SlWallet,
              isActive: false,
              link: "earnings/wallet-history",
            },
            {
              id: 2,
              label: "Wallet Request",
              Icon: CiWallet,
              isActive: false,
              link: "earnings/wallet-request",
            },
            {
              id: 2,
              label: "Transaction History",
              Icon: CiCreditCard1,
              isActive: false,
              link: "earnings/transaction-history",
            },
          ],
        },
      ],
    },
    {
      id: 5,
      Icon: BsMenuButtonWide,
      label: "Menu",
      isActive: false,
      link: "menu/category",
      submenus: [
        {
          accordion: "Menu",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Category",
              Icon: LuBoxes,
              isActive: false,
              link: "menu/category",
            },
            {
              id: 2,
              label: "Subcategory",
              Icon: BiCategoryAlt,
              isActive: false,
              link: "menu/subcategory",
            },
            {
              id: 3,
              label: "Item",
              Icon: TbBoxPadding,
              isActive: false,
              link: "menu/item",
            },
          ],
        },
        // {
        //   accordion: "Modifier",
        //   isActive: false,
        //   menu: [
        //     {
        //       id: 1,
        //       label: "Modifier Category",
        //       Icon: LuClipboardSignature,
        //       isActive: false,
        //       link: "menu/modifier-category",
        //     },
        //   ],
        // },
        // {
        //   accordion: "Courier",
        //   isActive: false,
        //   menu: [
        //     {
        //       id: 1,
        //       label: "Courier Service",
        //       Icon: TfiMenuAlt,
        //       isActive: false,
        //       link: "menu/courier-service",
        //     },
        //   ],
        // },
      ],
    },
    {
      id: 6,
      Icon: MdOutlineApproval,
      label: "Approvals",
      isActive: false,
      link: "approve-unapprove/category",
      submenus: [
        {
          accordion: "Menu",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Category",
              Icon: LuBoxes,
              isActive: false,
              link: "approve-unapprove/category",
            },
            {
              id: 2,
              label: "Subcategory",
              Icon: BiCategoryAlt,
              isActive: false,
              link: "approve-unapprove/subcategory",
            },
            {
              id: 3,
              label: "Item",
              Icon: TbBoxPadding,
              isActive: false,
              link: "approve-unapprove/item",
            },
            {
              id: 4,
              label: "Food Item",
              Icon: TbBoxPadding,
              isActive: false,
              link: "approve-unapprove/food-item",
            },
          ],
        },
        {
          accordion: "Advertisement",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Advertise",
              Icon: RiAdvertisementLine,
              isActive: false,
              link: "approve-unapprove/advertisement",
            },
          ],
        },
        {
          accordion: "Offers",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Promocode Approval",
              Icon: RiCoupon3Line,
              isActive: false,
              link: "approve-unapprove/promocode-approval",
            },
            {
              id: 2,
              label: "Sale Approval",
              Icon: FaStore,
              isActive: false,
              link: "approve-unapprove/sale-approval",
            },
          ],
        },
        {
          accordion: "User",
          isActive: false,
          menu: [
            {
              id: 1,
              label: "Vendor Approval",
              Icon: LuBoxes,
              isActive: false,
              link: "approve-unapprove/user-approval",
            },
            {
              id: 2,
              label: "Customer Approval",
              Icon: LuBoxes,
              isActive: false,
              link: "approve-unapprove/customer-approval",
            },
          ],
        },
      ],
    },
    {
      id: 7,

      Icon: SlUser,

      label: "Users",

      isActive: false,

      link: "users/user",

      submenus: [
        {
          accordion: false,

          isActive: false,

          menu: [
            {
              id: 1,

              label: "User",

              Icon: SlUser,

              isActive: false,

              link: "users/user",
            },

            {
              id: 2,

              label: "Deliveryman",

              Icon: TfiUser,

              isActive: false,

              link: "users/deliveryman",
            },

            {
              id: 3,

              label: "Store",

              Icon: RiStore2Line,

              isActive: false,

              link: "users/store",
            },
          ],
        },
      ],
    },
    // ADD THIS OBJECT AT 8th INDEX (before Delivery Info menu)

    {
      id: 8,

      Icon: RiCustomerService2Line,

      label: "Ticket Management",

      isActive: false,

      link: "ticket-management/all-tickets",

      submenus: [
        {
          accordion: false,

          isActive: false,

          menu: [
            {
              id: 1,

              label: "All Tickets",

              Icon: RiCustomerService2Line,

              isActive: false,

              link: "ticket-management/all-tickets",
            },
          ],
        },
      ],
    },
    {
      id: 9,

      Icon: TbTruckDelivery,

      label: "Delivery Info",

      isActive: false,

      link: "delivery-info/delivery",

      submenus: [
        {
          accordion: false,

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Delivery",

              Icon: CiDeliveryTruck,

              isActive: false,

              link: "delivery-info/delivery",
            },
            // commented for futher modifications
            // {
            //   id: 2,

            //   label: "Country-City",

            //   Icon: CiGlobe,

            //   isActive: false,

            //   link: "delivery-info/country-city-info",
            // },

            {
              id: 2,

              label: "Delivery Fees",

              Icon: IoPrintOutline,

              isActive: false,

              link: "delivery-info/delivery-fees",
            },
            {
              id: 3,

              label: "Parcel Category Fees",

              Icon: IoPrintOutline,

              isActive: false,

              link: "delivery-info/parcel-category-fees",
            },
          ],
        },
      ],
    },
    {
      id: 10,

      Icon: MdOutlineLocalOffer,

      label: "Promotion Management",

      isActive: false,

      link: "promotion-management/promocode",

      submenus: [
        {
          accordion: false,

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Promocode",

              Icon: RiCoupon3Line,

              isActive: false,

              link: "promotion-management/promocode",
            },
            {
              id: 2,

              label: "Promotional Sale",

              Icon: MdOutlineLocalOffer,

              isActive: false,

              link: "promotion-management/promosale",
            },

            {
              id: 3,

              label: "Advertise",

              Icon: RiAdvertisementLine,

              isActive: false,

              link: "promotion-management/advertisement",
            },

            {
              id: 4,

              label: "Refferal",

              Icon: VscReferences,

              isActive: false,

              link: "promotion-management/referral",
            },
          ],
        },
      ],
    },
    {
      id: 11,

      Icon: IoSettingsOutline,

      label: "Settings",

      isActive: false,

      link: "settings/basic-settings/admin",

      submenus: [
        {
          accordion: "Basic Settings",

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Admin",

              Icon: SlUserFollowing,

              isActive: false,

              link: "settings/basic-settings/admin",
            },
            {
              id: 2,

              label: "Document",

              Icon: SlDocs,

              isActive: false,

              link: "settings/basic-settings/document",
            },

            {
              id: 3,

              label: "Language",

              Icon: TfiPrinter,

              isActive: false,

              link: "settings/basic-settings/language",
            },
          ],
        },
        {
          accordion: "Roles/Permissions",

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Multi Level Approvals",

              Icon: FaUserFriends,

              isActive: false,

              link: "settings/roles-and-permissions/multi-level-approval",
            },
            {
              id: 2,

              label: "User Role",

              Icon: FaUserFriends,

              isActive: false,

              link: "settings/roles-and-permissions/user-role",
            },
            {
              id: 3,

              label: "Permissions",

              Icon: LiaBuromobelexperte,

              isActive: false,

              link: "settings/roles-and-permissions/permissions",
            },
            {
              id: 4,

              label: "Add User",

              Icon: SlUserFollowing,

              isActive: false,

              link: "settings/roles-and-permissions/add-user",
            },
            {
              id: 5,

              label: "Component Type",

              Icon: CgUiKit,

              isActive: false,

              link: "settings/roles-and-permissions/component-type",
            },
            {
              id: 6,

              label: "Components",

              Icon: SiHyperskill,

              isActive: false,

              link: "settings/roles-and-permissions/components",
            },
            {
              id: 7,

              label: "Assign Permissions",

              Icon: TiGroupOutline,

              isActive: false,

              link: "settings/roles-and-permissions/assign-permission",
            },
          ],
        },
        // {
        //   accordion: "Discount",

        //   isActive: false,

        //   menu: [
        //     {
        //       id: 1,

        //       label: "Promo Code ",

        //       Icon: SlUserFollowing,

        //       isActive: false,

        //       link: "settings/discount/promo-code",
        //     },

        //     {
        //       id: 2,

        //       label: "Advertise",

        //       Icon: SlDocs,

        //       isActive: false,

        //       link: "settings/basic-settings/document",
        //     },

        //     {
        //       id: 3,

        //       label: "Refferal",

        //       Icon: TfiPrinter,

        //       isActive: false,

        //       link: "settings/basic-settings/language",
        //     },
        //   ],
        // },
        {
          accordion: "Masters",

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Tax Master",

              Icon: LuBadgePercent,

              isActive: false,

              link: "settings/master/tax-master",
            },
            {
              id: 2,

              label: "Tax Regime",

              Icon: LuBadgePercent,

              isActive: false,

              link: "settings/master/tax-regime",
            },
            {
              id: 3,

              label: "Vehical Type",

              Icon: AiOutlineTruck,

              isActive: false,

              link: "settings/master/vehical-type",
            },
            {
              id: 4,

              label: "Region Type",

              Icon: GrLocationPin,

              isActive: false,

              link: "settings/master/region-type",
            },
            {
              id: 5,

              label: "Delivery Type",

              Icon: MdDeliveryDining,

              isActive: false,

              link: "settings/master/delivery-type",
            },

            // {
            //   id: 2,

            //   label: "Deliveryman Settings ",

            //   Icon: SlDocs,

            //   isActive: false,

            //   link: "settings/master/setting-master",
            // },

            // {
            //   id: 3,

            //   label: "Customer Settings",

            //   Icon: TfiPrinter,

            //   isActive: false,

            //   link: "settings/basic-settings/language",
            // },
          ],
        },
        {
          accordion: "Template",

          isActive: false,

          menu: [
            {
              id: 1,

              label: "Email",

              Icon: MdOutlineEmail,

              isActive: false,

              link: "settings/template/emails",
            },

            {
              id: 2,

              label: "SMS ",

              Icon: MdOutlineTextsms,

              isActive: false,

              link: "settings/template/sms",
            },

            {
              id: 3,

              label: "Privacy & Terms",

              Icon: MdOutlinePrivacyTip,

              isActive: false,

              link: "settings/template/privacy-and-terms",
            },
            {
              id: 4,

              label: "Cancellation Reson",

              Icon: TbMessage2Cancel,

              isActive: false,

              link: "settings/template/cancelation",
            },
          ],
        },
      ],
    },
  ]);

  const route =
    location.pathname.split("/app/")[1] === undefined
      ? ""
      : location.pathname.split("/app/")[1];
  // console.log("location", route);

  const setActiveMenu = (items, route) => {
    return items.map((item) => {
      // console.log(
      //   " fileteredRotues.includes(route)",
      //   fileteredRotues.some((r) => r.path === route)
      // );

      item.isActive =
        fileteredRotues.some((r) => r.path === route) && item.link === route;

      if (item.submenus) {
        item.submenus = item.submenus.map((submenu) => {
          submenu.isActive = false;
          submenu.menu = submenu.menu.map((subItem) => {
            subItem.isActive = subItem.link === route;
            if (subItem.isActive) {
              submenu.isActive = true; // If a subitem is active, set the submenu to active
            }
            return subItem;
          });
          if (submenu.isActive) {
            item.isActive = true; // If a submenu is active, set the item to active
          }
          return submenu;
        });
      }

      return item;
    });
  };

  const Active = () => {
    // const menus = navItems.map((item) => {
    //   if (route === item.link || route === undefined) {
    //     item.isActive = true;
    //   } else {
    //     item.isActive = false;
    //   }
    //   return item;
    // });
    const updatedMenus = setActiveMenu(navItems, route);
    handleActiveMenu(updatedMenus);
    setNavItems(updatedMenus);
  };

  const handleActive = (menu) => {
    const menus = navItems.map((item) => {
      if (item.id === menu.id) {
        item.isActive = true;
      } else {
        item.isActive = false;
      }
      return item;
    });
    handleActiveMenu(menus);
    setNavItems(menus);
  };

  useEffect(() => {
    Active();
  }, []);

  return (
    <div className={styles.SideBarMenus}>
      <ul className={styles.nav}>
        {navItems.map(({ id, Icon, label, isActive, link }, i) =>
          fileteredRotues.some((r) => r.path === link) ? (
            <li
              key={i}
              className={
                isActive
                  ? [`${styles.navItem} ${styles.active}`]
                  : styles.navItem
              }
              onClick={() => handleActive({ id, Icon, label, isActive, link })}
            >
              <Icon
                style={{
                  fontSize: "1.5rem",
                  lineHeight: "2.5rem",
                  // color: "#48494b",
                  background: "",
                }}
                className={isActive ? "text-red-600" : "#48494b"}
              />
              <Link className={` text-nowrap ${styles.navLink}`} to={link}>
                {label}
              </Link>
            </li>
          ) : (
            ""
          ),
        )}
      </ul>
    </div>
  );
}

export default SideBar;
